var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border border-radius form-control html-textarea",attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.value)},on:{"input":_vm.updateHTML}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b598566c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/common/html-textarea/html-textarea.html
// module id = null
// module chunks = 